import { httpClient } from '../../../lib/utils';
import { envValue } from '../../../config/envUtils';
import { SAVE_LEVEL } from '../../constants/Level';
import store from '../../store/Store';
import { Service } from '../../services/Service';
//TODO: refactor into service
export function fetchLabels(chainId, hotelId, languageCode, setLabels, setHigherOrderLabels) {
    const SOURCEURL = envValue('SOURCEURL');
    const selectedLevel = store.getState().app.selected.level;
    return httpClient
        .get(
            `${SOURCEURL}/shs-bedesigner-services/v1/contents/labels?${Service.paramProxy(
                chainId,
                hotelId,
                null,
                selectedLevel
            )}&contentcode=${languageCode}${
                selectedLevel === SAVE_LEVEL.HOTEL ? '&foldlevel=brand' : '&foldlevel=chain'
            }`
        )
        .then(foldedResponse => {
            const resultCode = foldedResponse.data.Result.ResultCode;
            const value = foldedResponse.data.BEDesignerResult.Value;
            const foldedValue = value.Folded;
            if (resultCode === 'SUCCESS') {
                if (typeof setHigherOrderLabels === 'function') {
                    setHigherOrderLabels(foldedValue);
                }
                return Promise.resolve([foldedValue]);
            } else {
                return Promise.reject('Cannot retrieve labels at this time');
            }
        })
        .then(foldedValue => {
            return httpClient
                .get(
                    `${SOURCEURL}/shs-bedesigner-services/v1/contents/labels?${Service.paramProxy(
                        chainId,
                        hotelId,
                        null,
                        selectedLevel
                    )}&contentcode=${languageCode}&foldlevel=${selectedLevel}&explicitlevel=${selectedLevel}`
                )
                .then(responseFromChain => {
                    const resultCode = responseFromChain.data.Result.ResultCode;
                    const value = responseFromChain.data.BEDesignerResult.Value;
                    const foldedValue = value.Folded;
                    const explicitValue = value.hasOwnProperty('Explicit') ? value.Explicit.Data : null;
                    if (resultCode === 'SUCCESS') {
                        if (typeof setLabels === 'function') {
                            setLabels(foldedValue, explicitValue, languageCode);
                        }
                        return Promise.resolve([foldedValue, explicitValue, languageCode]);
                    } else {
                        return Promise.reject('Cannot retrieve labels at this time');
                    }
                });
        });
}

export function fetchEnglishLabels(chainId, hotelId, languageCode) {
    const SOURCEURL = envValue('SOURCEURL');
    const selectedLevel = store.getState().app.selected.level;
    return httpClient
        .get(`${SOURCEURL}/shs-bedesigner-services/v1/contents/labels/systemdefault?contentcode=en-US`)
        .then(response => {
            const resultCode = response.data.Result.ResultCode;
            const value = response.data.BEDesignerResult.Value.Data;
            if (resultCode === 'SUCCESS') {
                store.dispatch({
                    type: 'SET_ENGLISH_LABELS',
                    value: value
                });
                return Promise.resolve(value);
            } else {
                return Promise.reject('Cannot retrieve labels at this time');
            }
        });
}



// WEBPACK FOOTER //
// ./src/components/helpers/fetchLabels.js